import React, { useState } from 'react'

import {
  StyleSheet,
  View,
  Text,
  Dimensions
} from 'react-native'

import {
  Space,
  Slider,
  Switch,
  Button
} from '@sart/components'

import { useContent } from '@sart/content'

import {
  adaptive,
  colors,
  typography
} from '@sart/styles'

import { testID } from '@sart/utilities'

export default function BuildYourPlan(props) {

  const content = useContent()

  const [recurring, setRecurring] = useState(true)

  function handleSliderChange() {

  }

  function handleCheckout() {

  }

  return (
    <View style={styles.container}>
      <Space height={25} />
      <Text style={styles.description}>{content.buildPlan.description}</Text>
      <Space height={25} />

      <View style={styles.switchContainer}>
        <Text style={[styles.switchLabels, { textAlign: 'right' }]}>{content.buildPlan.switch12}</Text>
        <Space width={12} />
        <Switch
          value={recurring}
          onValueChange={value => setRecurring(value)}
          trackColor={{ true: colors.srDarkGreen, false: colors.trivial }}
          ios_backgroundColor={colors.trivial}
          thumbColor={colors.white}
          {...testID('buildPlansSwitch')}
        />
        <Space width={12} />
        <Text style={[styles.switchLabels, { textAlign: 'left' }]}>{content.buildPlan.switch24}</Text>
      </View>

      <View style={styles.slidersContainer}>
        <View style={styles.sliderRow}>
          <View style={styles.sliderDetails}>
            <Text style={styles.sliderDetailsText}>{content.navigation.texts}</Text>
            <Text style={styles.sliderDetailsText}>50</Text>
          </View>
          <Space height={8} />
          <Slider
            value={50}
            step={1}
            minimumValue={0}
            maximumValue={400}
            onValueChange={handleSliderChange}
          />
        </View>
        <Space height={24} />

        <View style={styles.sliderRow}>
          <View style={styles.sliderDetails}>
            <Text style={styles.sliderDetailsText}>{content.navigation.minutes}</Text>
            <Text style={styles.sliderDetailsText}>100</Text>
          </View>
          <Space height={8} />
          <Slider
            value={100}
            step={1}
            minimumValue={0}
            maximumValue={300}
            onValueChange={handleSliderChange}
          />
        </View>
        <Space height={24} />

        <View style={styles.sliderRow}>
          <View style={styles.sliderDetails}>
            <Text style={styles.sliderDetailsText}>{content.navigation.data}</Text>
            <Text style={styles.sliderDetailsText}>50GB</Text>
          </View>
          <Space height={8} />
          <Slider
            value={50}
            step={1}
            minimumValue={0}
            maximumValue={60}
            onValueChange={handleSliderChange}
          />
        </View>
      </View>

      <Space height={24} />

      <Text style={styles.price}>£12.00 / Month</Text>

      <Space height={24} />

      <Button 
        title={content.navigation.checkout}
        onPress={handleCheckout}
        style={styles.button}
        titleStyle={styles.buttonTitle}
        {...testID('buildPlanButton')}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-start',
    ...adaptive.wrapperPadding
  },
  description: {
    color: colors.srTextInput,
    fontSize: 16,
    ...typography.medium
  },
  switchContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    // paddingTop: 5,
    ...adaptive.switchContainerPadding,
    // paddingBottom: 20,
  },
  switchLabels: {
    flex: 1,
    fontSize: 20,
    // lineHeight: 20,
    fontWeight: '600',
    color: colors.srDarkGreen,
    ...typography.lightbold
  },
  slidersContainer: {

  },
  sliderRow: {

  },
  sliderDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  sliderDetailsText: {
    color: colors.srDarkGreen,
    fontSize: 18,
    ...typography.bold
  },
  price: {
    textAlign: 'right',
    color: colors.srDarkGreen,
    fontSize: 22,
    ...typography.bold
  },
  button: {
    backgroundColor: colors.srDarkGreen
  },
  buttonTitle: {
    ...typography.bold, 
    fontSize: 18, 
    color: colors.white
  }
})
